import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IInfrastructuresItem } from 'store/slices/infrastructures/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadInfrastructuresItem,
  saveInfrastructuresItem,
} from 'store/slices/infrastructures/actions';

import { InfrastructuresForm } from './components/InfrastructuresForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.infrastructures);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadInfrastructuresItem(id));
  }, []);

  const onFinish = (values: IInfrastructuresItem) => {
    setIsLoading(true);
    dispatch(saveInfrastructuresItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/infrastructures');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/infrastructures');
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <InfrastructuresForm
          onFinish={onFinish}
          cancelButtonHandler={cancelButtonHandler}
          isLoading={isLoading}
          initialValues={mapValuesToForm(item)}
        />
      ) : null}
    </MainLayout>
  );
};
